import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-region-view-list',
  imports: [RouterOutlet],
  templateUrl: './region-view-list.html',
  styleUrl: './region-view-list.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegionViewList {}
